module.exports = __webpack_public_path__ + "img/1.bcd3a460.png";